import {CSSProperties} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    slug: string;
    size?: string;
    /** "light" repaints the artwork white for placement on a dark background. */
    tone?: "dark" | "light";
    className?: string;
}

const CITY_ICON_SOURCES: Record<string, string> = {
    bialystok: require("../../images/city_icons/bialystok.svg"),
    bydgoszcz: require("../../images/city_icons/bydgoszcz.svg"),
    gdansk: require("../../images/city_icons/gdansk.svg"),
    katowice: require("../../images/city_icons/katowice.svg"),
    kielce: require("../../images/city_icons/kielce.svg"),
    krakow: require("../../images/city_icons/krakow.svg"),
    lodz: require("../../images/city_icons/lodz.svg"),
    lublin: require("../../images/city_icons/lublin.svg"),
    olsztyn: require("../../images/city_icons/olsztyn.svg"),
    poznan: require("../../images/city_icons/poznan.svg"),
    rzeszow: require("../../images/city_icons/rzeszow.svg"),
    szczecin: require("../../images/city_icons/szczecin.svg"),
    warszawa: require("../../images/city_icons/warszawa.svg"),
    wroclaw: require("../../images/city_icons/wroclaw.svg")
};

export const PricesHubCityIcon = (props: IProps) => {
    const {slug, size = "2.8", tone = "dark", className} = props;
    const source = CITY_ICON_SOURCES[slug];
    const sizeStyle = {"--prices-hub-city-icon-size": `${size}rem`} as CSSProperties;

    if (!source) {
        return null;
    }

    return (
        <span className={cx(iconHolderStyle, className)} style={sizeStyle} aria-hidden="true">
            <img src={source} alt="" className={tone === "light" ? lightIconStyle : iconStyle} loading="lazy" decoding="async" />
        </span>
    );
};

const iconHolderStyle = css({
    display: "inline-flex",
    flex: "0 0 auto",
    alignItems: "center",
    justifyContent: "center",
    width: "var(--prices-hub-city-icon-size)",
    height: "var(--prices-hub-city-icon-size)"
});

const iconStyle = css({
    display: "block",
    width: "100%",
    height: "100%"
});

const lightIconStyle = css({
    display: "block",
    width: "100%",
    height: "100%",
    filter: "brightness(0) invert(1)"
});
import {CSSProperties} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    slug: string;
    size?: string;
    /** "light" repaints the artwork white for placement on a dark background. */
    tone?: "dark" | "light";
    className?: string;
}

const CITY_ICON_SOURCES: Record<string, string> = {
    bialystok: require("../../images/city_icons/bialystok.svg"),
    bydgoszcz: require("../../images/city_icons/bydgoszcz.svg"),
    gdansk: require("../../images/city_icons/gdansk.svg"),
    katowice: require("../../images/city_icons/katowice.svg"),
    kielce: require("../../images/city_icons/kielce.svg"),
    krakow: require("../../images/city_icons/krakow.svg"),
    lodz: require("../../images/city_icons/lodz.svg"),
    lublin: require("../../images/city_icons/lublin.svg"),
    olsztyn: require("../../images/city_icons/olsztyn.svg"),
    poznan: require("../../images/city_icons/poznan.svg"),
    rzeszow: require("../../images/city_icons/rzeszow.svg"),
    szczecin: require("../../images/city_icons/szczecin.svg"),
    warszawa: require("../../images/city_icons/warszawa.svg"),
    wroclaw: require("../../images/city_icons/wroclaw.svg")
};

export const PricesHubCityIcon = (props: IProps) => {
    const {slug, size = "2.8", tone = "dark", className} = props;
    const source = CITY_ICON_SOURCES[slug];
    const sizeStyle = {"--prices-hub-city-icon-size": `${size}rem`} as CSSProperties;

    if (!source) {
        return null;
    }

    return (
        <span className={cx(iconHolderStyle, className)} style={sizeStyle} aria-hidden="true">
            <img src={source} alt="" className={tone === "light" ? lightIconStyle : iconStyle} loading="lazy" decoding="async" />
        </span>
    );
};

const iconHolderStyle = css({
    display: "inline-flex",
    flex: "0 0 auto",
    alignItems: "center",
    justifyContent: "center",
    width: "var(--prices-hub-city-icon-size)",
    height: "var(--prices-hub-city-icon-size)"
});

const iconStyle = css({
    display: "block",
    width: "100%",
    height: "100%"
});

const lightIconStyle = css({
    display: "block",
    width: "100%",
    height: "100%",
    filter: "brightness(0) invert(1)"
});
